export default __webpack_public_path__ + "static/media/girl9.63d5d33e.png";